(function () {
	'use strict';

	angular
		.module('wizard-english-test.services')
		.service('HelperService', HelperService)

	/** @ngInject */
	function HelperService($window, $timeout, $state, $rootScope, NotifyService, ROUTES, APP) {
		const HelperService = {
			handleOnRun,
			handleStateChangeStart,
			handleStateChangeSuccess,
			handleStateChangeError,
			handleViewContentLoaded,
			errorCallback,
			retryCallback,
			successCallback,
			startLoading,
			stopLoading,
			setErrorMessageForm,
			removeErrorMessageForm,
			isScreenSmaller,
			scrollTo,
			passwordValidator,
			getFlowOptionsDefaults,
			convertObjectProperties,
			saveToLocalStorage,
			getFromLocalStorage,
			removeFromLocalStorage,
			isDevelopment
		};

		return HelperService;

		/**
		 * Auxiliar method executed when the system is starting
		 */
		function handleOnRun() {
			$rootScope.removeMessage = removeErrorMessageForm;
			$rootScope.isMobile = isScreenSmaller(767);
			$rootScope.currentYear = moment().format('YYYY');
		}

		/**
		 * Auxiliar method to execute the necessary methods on the route change start
		 *
		 * @param {object} transition - The executing transition
		 */
		function handleStateChangeStart(transition) {
			return transition;
		}

		/**
		 * Auxiliar method executed on every route state successfull change
		 */
		function handleStateChangeSuccess() {
			if ($window.screen.width <= 768) {
				$('#navbarNav').collapse('hide');
			}
		}

		/**
		 * Auxiliar method executed when the route change fails
		 *
		 * @param {object} error - The transition error
		 */
		function handleStateChangeError(error) {
			if (error && error.redirTo)
				$state.go(error.redirTo);
		}

		/**
		 * Auxiliar method executed once the system has finished loading all of it's content
		 */
		function handleViewContentLoaded() {
			AOS.init();
		}

		function errorCallback(error) {
			let message = 'Ocorreu um erro inesperado, por favor tente novamente.';

			if (error && error.Error && error.Message)
				message = error.Message;

			NotifyService.error(message);
		}

		function retryCallback(error, retryFunction) {
			let message = 'Ocorreu um erro inesperado, por favor tente novamente.';

			if (error && error.Error && error.Message)
				message = error.Message;

			NotifyService.notify({
				title: 'Erro!',
				type: 'error',
				text: message,
				showCancelButton: false,
				confirmButtonText: 'Tentar novamente',
				allowEscapeKey: false,
				allowOutsideClick: false
			}, retryFunction, retryFunction);
		}

		function successCallback(type = 'create') {
			let message = '';

			if (type == 'create')
				message = 'Registro salvo com sucesso.';

			else if (type == 'update')
				message = 'Registro atualizado com sucesso.';

			else if (type == 'delete')
				message = 'Registro apagado com sucesso.';

			NotifyService.success(message);
		}

		function startLoading(element, message = null, isFullScreen = false) {
			$timeout(() => {
				let widget = $(element).closest('[data-widget]');

				if ($(element).attr('[data-widget]'))
					widget = $(element);

				const loadingBody = document.createElement('div');

				if (isFullScreen == true)
					loadingBody.className = 'loading-body full'
				else
					loadingBody.className = 'loading-body';

				const loadingContent = document.createElement('div');
				loadingContent.className = 'loading-content';

				$(loadingContent).append(`<img src="/app/dist/images/progress-dot-white.svg" alt="Carregando, aguarde..." />`);

				if (message)
					$(loadingContent).append(`<p>${message}</p>`);

				loadingBody.appendChild(loadingContent);

				widget.append(loadingBody);
			})
		}

		function stopLoading(element) {
			$timeout(() => {
				let widget = $(element).closest('[data-widget]');

				if ($(element).attr('[data-widget]'))
					widget = $(element);

				widget
					.find('.loading-body')
					.fadeOut(function () {
						$(this).remove();
					});
			})
		}

		function setErrorMessageForm(input, message) {
			let errorMessage = 'Este campo é obrigatório';

			if (message)
				errorMessage = message;

			if (!$(input).parent().find('.validationMessage').length) {
				$(input).parent()
					.append(`<label class=\'control-label has-error validationMessage\'>${errorMessage}</label>`);

				$(input)
					.addClass('has-error')
					.parents('.form-group')
					.addClass('has-error');
			}

			$([document.documentElement, document.body]).animate({
				scrollTop: $(input).offset().top - ($('.header').outerHeight() + 30)
			}, 600);
		}

		function removeErrorMessageForm(input) {
			$(input)
				.parent()
				.find('.validationMessage')
				.remove();

			$(input)
				.removeClass('has-error')
				.parents('.form-group')
				.removeClass('has-error');
		}

		function isScreenSmaller(size) {
			return Modernizr.mq(`(max-width: ${size}px)`);
		}

		function scrollTo(navTo) {
			if ($rootScope.isMobile) {
				$('html, body').animate({
					scrollTop: ($(navTo).offset().top - ($('.navbar').outerHeight()) + 210)
				}, 600);
			} else {
				$('html, body').animate({
					scrollTop: ($(navTo).offset().top - ($('.navbar').outerHeight()) + 10)
				}, 600);
			}
		}

		function passwordValidator(password) {
			if (!password)
				return false;

			if (password.length < 8)
				return 'A senha deve conter ao menos 8 caracteres';

			if (!password.match(/[A-Z]/))
				return 'A senha deve conter ao menos um caracter maiúsculo';

			if (!password.match(/[0-9]/))
				return 'A senha deve conter ao menos um caracter numérico';

			return true;
		}

		function getFlowOptionsDefaults() {
			return {
				permanentErrors: [500, 501, 428],
				maxChunkRetries: 1,
				chunkRetryInterval: 5000,
				simultaneousUploads: 1,
				allowDuplicateUploads: true,
				singleFile: true,
				target: `${ROUTES.API}/file/upload`
			}
		}

		function convertToPascalCase(s) {
			return s.match(/[a-z]+/gi)
				.map(function (word) {
					return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
				})
				.join('');
		}

		function convertObjectProperties(obj) {
			const keyValues = Object.keys(obj).map(key => {
				if (typeof obj[key] === 'boolean')
					obj[key] = Boolean(obj[key]);

				if (obj[key] && !isNaN(obj[key]) && typeof obj[key] !== 'boolean')
					obj[key] = Number(obj[key]);

				if (obj[key] instanceof Array)
					obj[key] = obj[key].map(elem => convertObjectProperties(elem));

				if (obj[key] instanceof Object && !(obj[key] instanceof Array))
					obj[key] = convertObjectProperties(obj[key]);

				const newKey = convertToPascalCase(key);
				return {
					[newKey]: obj[key]
				};
			});

			return Object.assign({}, ...keyValues);
		}

		function saveToLocalStorage(name, data) {
			localStorage.setItem(`${APP.IDENTIFIER}_${name}`, JSON.stringify(data));
		}

		function removeFromLocalStorage(name) {
			localStorage.removeItem(`${APP.IDENTIFIER}_${name}`);
		}

		function getFromLocalStorage(name) {
			let data = localStorage.getItem(`${APP.IDENTIFIER}_${name}`);
			return JSON.parse(data);
		}

		function isDevelopment() {
			return APP.IS_DEV == "isDevTrue";
		}
	}
}());